import {Navigate, Outlet, RouteObject} from 'react-router';

/**
 * The Directory screens, mounted in two areas:
 *  - /dashboard/directory/*  — staff dashboard (dashboard sidebar)
 *  - /admin/directory/*      — admin area (admin sidebar)
 * The same pages; links inside them stay in the current area (directory-base.ts).
 * Each page's permission is in config/staff-access.php and enforced again by
 * the API.
 */
function DirectoryShell() {
  // The dashboard panel does not scroll by itself the way the admin content does.
  return (
    <div className="h-full overflow-y-auto">
      <Outlet />
    </div>
  );
}

const pages = (): RouteObject[] => [
  {path: 'listings', lazy: () => import('@app/opportunities/admin/opp-admin-datatable-page')},
  {path: 'listings/new', lazy: () => import('@app/opportunities/admin/opp-admin-type-selector')},
  {path: 'listings/:type/new', lazy: () => import('@app/opportunities/admin/opp-admin-form-page')},
  {path: 'listings/:type/:id/edit', lazy: () => import('@app/opportunities/admin/opp-admin-form-page')},
  {path: 'companies', lazy: () => import('@app/opportunities/admin/company-datatable-page')},
  {path: 'companies/contract', lazy: () => import('@app/opportunities/admin/company-contract-page')},
  {path: 'companies/new', lazy: () => import('@app/opportunities/admin/company-form-page')},
  {path: 'companies/:id/edit', lazy: () => import('@app/opportunities/admin/company-form-page')},
  {path: 'categories', lazy: () => import('@app/opportunities/admin/opp-admin-categories-page')},
  {path: 'applications', lazy: () => import('@app/opportunities/admin/directory-applications-page')},
];

export const directoryDashboardRoutes: RouteObject[] = [
  {
    path: 'directory',
    element: <DirectoryShell />,
    children: [
      {index: true, element: <Navigate to="listings" replace />},
      ...pages(),
      {path: 'boosts', lazy: () => import('@app/admin/listing-boosts-page')},
      {path: 'reports', lazy: () => import('@app/admin/listing-reports-page')},
      {path: 'questions', lazy: () => import('@app/admin/listing-questions-page')},
    ],
  },
];

/** The same screens inside the admin area, at their original admin addresses. */
export const directoryAdminRoutes: RouteObject[] = [
  {path: 'directory', element: <Navigate to="/admin/directory/listings" replace />},
  ...pages().map(route => ({...route, path: `directory/${route.path}`})),
  {path: 'listing-boosts', lazy: () => import('@app/admin/listing-boosts-page')},
  {path: 'opp/reports', lazy: () => import('@app/admin/listing-reports-page')},
  {path: 'opp/questions', lazy: () => import('@app/admin/listing-questions-page')},
];
